import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectSiteTokenDetails } from '../../../../../../../common/redux/features/playground/selectors';
import { HighlightDisplay } from '../../../../../PageElements/HighlightDisplay';
import { injectToken } from '../../../../exampleTransformations';
import oceanicNext from './oceanicNext';
import { getDefaultLanguage } from './utils';
import { EXAMPLE_TYPES } from '../../../../types';

interface CodeBoxProps {
  example: any;
  renderFor: EXAMPLE_TYPES;
}

export const CodeBox = ({ example, renderFor }: CodeBoxProps) => {
  const selectedSiteTokenDetails = useSelector(selectSiteTokenDetails);

  const language = useMemo(() => {
    return getLanguage();
  }, [example.type, renderFor]);

  const exampleToRender = useMemo(() => {
    const exampleContent =
      renderFor === EXAMPLE_TYPES.RESPONSE ? example.response : example.body;
    return injectToken(
      exampleContent.join('\r\n'),
      selectedSiteTokenDetails?.token || '',
    );
  }, [renderFor, example, selectedSiteTokenDetails]);

  return (
    <HighlightDisplay
      value={exampleToRender}
      language={language}
      theme={oceanicNext}
      withLineNumber={true}
    />
  );

  function getLanguage() {
    if (renderFor === EXAMPLE_TYPES.RESPONSE) {
      return 'json'; // response is always a json
    }
    if (example.type === 'curl') {
      return 'bash';
    }
    if (!example.type) {
      return getDefaultLanguage(renderFor);
    }
    return example.type && example.type.toLowerCase();
  }
};
